export enum LogType {
    AppEvent = 1,
    UserAction = 2
}
